export default {
    state: {
        validating: false,
        workflow: 'overview'
    },
    mutations: {
        setValidating (state, payload) {
            state.validating = payload
        },
        setWorkflow (state, payload) {
            state.workflow = payload
        }
    },
    actions: {

    }
}
